var _style, _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVimbalIconEarth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000041976595678592000180000017872339785167748511_);}\n\t.st2{fill:#2C5868;}\n\t.st3{fill:url(#SVGID_00000157271131467961520330000018444770926787291014_);}\n\t.st4{fill:url(#SVGID_00000107579305660817651620000014933979057447859129_);}\n\t.st5{fill:#4F6445;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.8453,
    y1: 796.9107,
    x2: 897.1547,
    y2: 796.9107
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C5868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3805,
    style: {
      stopColor: "#4F6445"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8822,
    style: {
      stopColor: "#8F5329"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M539.62,981.11c-17.52,0-34-6.82-46.39-19.22L190.72,659.38c-10.5-10.5-10.5-27.53,0-38.03 c10.5-10.5,27.53-10.5,38.02,0l302.51,302.51c3.01,3.01,6.53,3.46,8.36,3.46s5.35-0.45,8.36-3.46l303.28-303.28 c10.5-10.5,27.53-10.5,38.02,0c10.5,10.5,10.5,27.53,0,38.03L586,961.89C573.62,974.28,557.14,981.11,539.62,981.11z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096038956542958313230000007131174246487512248_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.8453,
    y1: 394.2749,
    x2: 897.1547,
    y2: 394.2749,
    gradientTransform: "matrix(1 0 0 -1 0 677.3643)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2574,
    style: {
      stopColor: "#2C5868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5601,
    style: {
      stopColor: "#4F6445"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8F5329"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096038956542958313230000007131174246487512248_)"
    },
    d: "M539.62,98.89 c-17.52,0-34,6.82-46.39,19.22L190.72,420.62c-10.5,10.5-10.5,27.53,0,38.03c10.5,10.5,27.53,10.5,38.02,0l302.51-302.51 c3.01-3.01,6.53-3.46,8.36-3.46s5.35,0.45,8.36,3.46l303.28,303.28c10.5,10.5,27.53,10.5,38.02,0c10.5-10.5,10.5-27.53,0-38.03 L586,118.11C573.62,105.72,557.14,98.89,539.62,98.89z"
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M494.85,652.32c-11.35,0-21.02-8.66-22.06-20.19c-1.19-13.16-2.02-27.26-2.48-41.92 c-1.76-56.4,2.2-121.77,10.58-174.85c14.01-88.69,33.11-105.35,49.95-109.94c37.79-10.3,53.09,25.57,62.24,47.01 c4.81,11.27-0.43,24.3-11.7,29.1c-11.27,4.81-24.3-0.43-29.1-11.7c-1.78-4.17-5.81-13.63-9.17-19 c-14.52,26.21-31.75,132.65-28.46,238c0.43,13.79,1.21,27.02,2.32,39.32c1.1,12.2-7.89,22.98-20.09,24.08 C496.2,652.29,495.52,652.32,494.85,652.32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160172520731975767040000010051512546641126552_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.262,
    y1: 472.8235,
    x2: 463.5872,
    y2: 713.5439
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0249,
    style: {
      stopColor: "#2C5868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3575,
    style: {
      stopColor: "#4F6445"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160172520731975767040000010051512546641126552_)"
    },
    d: "M532.08,613.99c-0.15,0-0.3,0-0.45,0 l-0.41-0.01c-52.98-1.06-103.03-2.07-142.06-8.09c-19.9-3.07-80.47-12.42-81.88-57.79c-0.84-27.12,19.82-62.24,123.08-75.61 c12.15-1.59,23.27,7,24.84,19.15c1.57,12.15-7,23.27-19.15,24.84c-69.36,8.98-84.53,27.25-84.44,30.24 c0.06,0.32,5.13,10.24,51.48,16.37c35.37,4.68,80.86,5.59,129.01,6.56l0.41,0.01c12.25,0.25,21.98,10.37,21.73,22.62 C554,604.35,544.12,613.99,532.08,613.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091698973909761265350000005231159586553809833_",
    gradientUnits: "userSpaceOnUse",
    x1: 637.15,
    y1: 483.0219,
    x2: 784.6418,
    y2: 682.2741
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C5868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4143,
    style: {
      stopColor: "#4F6445"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091698973909761265350000005231159586553809833_)"
    },
    d: "M655.93,608.21 c-10.84,0-20.32-7.95-21.92-18.99c-1.76-12.12,6.64-23.38,18.76-25.14c2.08-0.3,4.97-0.62,7.94-0.94 c2.84-0.3,6.36-0.68,7.89-0.95c42.39-7.5,58.07-18.33,62.84-22.64c2.78-2.51,3.65-4.32,3.64-4.8 c-0.15-4.84-11.94-11.67-37.95-16.03c-32.2-5.4-77.1-6.02-124.64-6.68l-19.12-0.28c-12.25-0.19-22.02-10.28-21.83-22.53 c0.19-12.13,10.09-21.83,22.17-21.83c0.12,0,0.24,0,0.36,0l19.04,0.28c49.28,0.69,95.82,1.33,131.35,7.29 c20.97,3.52,36.86,8.71,48.59,15.88c21.1,12.9,25.99,30.24,26.37,42.51c0.31,10.05-2.6,25-18.26,39.13 c-16.81,15.17-45.35,26.4-84.82,33.38c-3.02,0.54-6.85,0.95-10.9,1.38c-2.36,0.25-4.65,0.49-6.3,0.73 C658.06,608.13,656.99,608.21,655.93,608.21z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M549.21,776.82c-19.2,0-44.96-11.56-61.83-64.76c-3.7-11.68,2.76-24.14,14.44-27.85 c11.68-3.69,24.15,2.76,27.85,14.44c7.66,24.14,15.81,31.88,18.72,33.47c9.31-9.24,29.07-66.31,23.67-239.46 c-0.43-13.81-1.21-27.04-2.32-39.33c-1.1-12.2,7.9-22.98,20.09-24.08c12.25-1.12,22.98,7.9,24.08,20.1 c1.19,13.15,2.02,27.25,2.48,41.93c1.52,48.6,1.86,118.66-5.12,176.4c-5.59,46.21-17.94,107.79-60.55,109.12 C550.22,776.81,549.71,776.82,549.21,776.82z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimbalIconEarth);
export default __webpack_public_path__ + "static/media/vimbal_icon_earth.fd7521e530dc33ba25286d7aa606b1a9.svg";
export { ForwardRef as ReactComponent };